<template>
  <div class="col-md-6 offset-md-3">
    <div class="login-form mt-4 p-4">
      <div class="row g-3">
        <h4>Задайте новый пароль</h4>
        <p>Вы подтвердили, что вы являетесь владельцем этого аккаунта.</p>
        <div class="col-12">
          <label>Новый пароль</label>
          <input type="password" name="password" class="form-control" placeholder="New password" v-model="password">
        </div>
        <div class="col-12 error-placeholder">
          <error-label/>
        </div>
        <div class="col-12">
          <button type="submit" class="btn btn-dark float-end ms-3" @click="handleClickActionRestoreSetPassword">Продолжить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageEmpty, type WebSocketMessageError } from "@/plugins/ws";
import ErrorLabel from "@/components/ui/ErrorLabel.vue";

import {RootState} from "@/store";

defineOptions({
  name: 'ComponentsAuthRestoreConfirm',
});

const emit = defineEmits<{
  switchMode: [mode: string];
}>();

const store = useStore<RootState>();

// Типы для WebSocket сообщений компонента RestoreConfirm
type RestoreSetPasswordMessage = WebSocketMessageEmpty<'auth-restore-set-password'>;
type RestoreSetPasswordFailMessage = WebSocketMessageError<'auth-restore-set-password-fail'>;

// Объединенный тип для всех сообщений
type RestoreConfirmWebSocketMessageType = RestoreSetPasswordMessage | RestoreSetPasswordFailMessage;

const internalInstance = getCurrentInstance();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const wsSend = internalInstance?.appContext.config.globalProperties.$wsSend as (signal: string, payload: any) => void;

const password = ref('');
const latestMessageValue = ref(latestMessage);

const setErrorReason = (reason: string) => store.dispatch('errorLabel/setErrorReason', reason);
const unsetErrorReason = () => store.dispatch('errorLabel/unsetErrorReason');

// WebSocket message handler
const handleWebSocketMessage = (data: RestoreConfirmWebSocketMessageType): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'auth-restore-set-password':
      signalRestoreSetPassword();
      break;
    case 'auth-restore-set-password-fail':
      signalRestoreSetPasswordFail(data.reason);
      break;
  }
};

watch(latestMessageValue, handleWebSocketMessage);

const handleClickActionRestoreSetPassword = () => {
  wsSend('authRestoreSetPassword', {
    newPassword: password.value,
  });
};

const signalRestoreSetPasswordFail = (payload: string) => {
  setErrorReason(payload);
};

const signalRestoreSetPassword = () => {
  unsetErrorReason();
  store.dispatch('auth/restoreSuccess');
  emit('switchMode', 'restoreSuccess');
};
</script>

<style scoped>

</style>